module.exports = __webpack_public_path__ + "static/media/DSC_0260.df68186d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0260.jpg
// module id = 656
// module chunks = 0